import axios from 'axios';

/**
 * Processes an uploaded image through the OCR service
 *
 * @param {Object} params
 * @param {string} params.key - S3 key from uploadImage
 * @param {string} params.fileType - MIME type (e.g., 'image/jpeg')
 * @returns Promise<Object> OCR results
 */
export const processImage = async ({ key, fileType }) => {
  const res = await axios.post('/ocr/image', {
    key,
    fileType
  });

  // returns the resulting data from the OCR service, insurance data
  // extracted from the insurance card that was uploaded.
  // { _ocr_subscriberName: 'JOHN DOE', ...}
  return res.data;
};
